import React from 'react';
import { DebouncedInput } from './DebouncedInput';
import { Column } from '@tanstack/react-table';
import { filterVariant } from './types';
import { Checkbox, Typography, Box } from '@mui/material';
import './Filters.scss';

export function FilterOption({
    column,
    onChange,
}: {
    column: Column<any, unknown>;
    onChange?: (name: string, value: string | number | boolean) => void;
}) {
    const { filterPlaceholder, filterVariant } = column.columnDef.meta ?? {};

    const columnFilterValue = column.getFilterValue();

    const onFilterChange = (value: string | number | boolean, variant: filterVariant) => {
        if (onChange) {
            onChange(column.id, value);
        }

        switch (variant) {
            case 'checkbox':
                return column.setFilterValue(value);
            case 'text':
            default:
                return column.setFilterValue(value);
        }
    };

    return filterVariant === 'checkbox' ? (
        <Box className="filter-checkbox-container">
            <Checkbox
                size="small"
                className="filter-checkbox"
                disableRipple={true}
                checked={!!columnFilterValue}
                onChange={(_event, checked) => onFilterChange(checked, 'checkbox')}
            />
            <Typography variant="body2">Show Disabled Users</Typography>
        </Box>
    ) : (
        <DebouncedInput
            type="text"
            value={(columnFilterValue ?? '') as string}
            onChange={(value) => onFilterChange(value, 'text')}
            placeholder={filterPlaceholder ?? 'Search... '}
            className="header-cell-filter"
        />
    );
}
